import { render, staticRenderFns } from "./OrderCoachsFilesCard.vue?vue&type=template&id=2d929a17"
import script from "./OrderCoachsFilesCard.vue?vue&type=script&lang=js"
export * from "./OrderCoachsFilesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports